if (process.env.NODE_ENV) {
  import('./dev.js')
}

import './dev.js';
import '../scss/main.scss';

// Import Font Awesome
import '@fortawesome/fontawesome-free/css/all.css';

// Import Bootstrap JavaScript for modal functionality
import 'bootstrap/js/dist/modal';

import './_notifications'
import './_header'
import './_moderate'
import './_search'
import './_endorsement.js'
import './_endorsement-requests.js'
import './_endorsement-search.js'
import './_search-federation.js'
import './_accordion.js'
import './_bootstrap_modal_zindex_fix.js'

// src/index.js
if (module.hot) {
  module.hot.accept();
}